<p-panel header="Registro de Menu">
    <div class="ui-g ui-fluid">
        <div class="ui-g-12 ui-lg-4">
            <div class="card no-margin">
                <p-tree [value]="items" selectionMode="single" (onNodeSelect)="nodeSelect($event.node)"></p-tree>
            </div>
        </div>

        <div class="ui-g-12 ui-lg-8">
            <div class="card no-margin">
                <p-panel header="Lista de {{titulo}}">
                    <p-table [value]="listModelo" [columns]="columnas" [paginator]="true" [rows]="globalConstants.sizePage" dataKey="idOpcion" editMode="row" autoLayout="true" [responsive]="true">
                        <!-- Header -->
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th *ngFor="let col of columns">
                                    {{col.header}}
                                </th>
                                <th colspan="2">Acciones</th>
                            </tr>
                        </ng-template>
                        <!-- body -->
                        <ng-template pTemplate="body" let-modelo let-editing="editing" let-ri="rowIndex">
                            <tr [pEditableRow]="modelo">
                                <td class="action-td">
                                    <span class="ui-column-title">Codigo</span> {{modelo.idOpcion}}
                                </td>
                                <td class="ui-fluid">
                                    <span class="ui-column-title">Descripción</span>
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <span class="p-float-label">
                                                <input id="float-input" type="text" pInputText [(ngModel)]="modelo.descripcionOpcion" size="100"> 
                                            </span>
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{modelo.descripcionOpcion}}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td class="ui-fluid">
                                    <span class="ui-column-title">KeyOpcion</span>
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <span class="p-float-label">
                                                {{modelo.keyOpcion}}
                                            </span>
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{modelo.keyOpcion}}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td class="action-td-action">
                                    <!-- <button *ngIf="!editing" pButton type="button" pInitEditableRow icon="{{globalConstants.icoEditar}}" (click)="onRowEditInit(modelo)"></button> -->
                                    <button [disabled]="buttonAcces.btnEditar" *ngIf="!editing" pButton type="button" pInitEditableRow icon="{{globalConstants.icoEditar}}" (click)="onRowEditInit(modelo)"></button>
                                    <button *ngIf="editing" pButton type="button" pSaveEditableRow icon="{{globalConstants.icoGrabar}}" class="ui-button-success" (click)="onRowEditSave(modelo)"></button>
                                    <button *ngIf="editing" pButton type="button" pCancelEditableRow icon="{{globalConstants.icoCancelar}}" class="ui-button-danger" style="margin-left: .5em" (click)="onRowEditCancel(modelo, ri)"></button>
                                </td>
                                <td class="action-td">
                                    <button [disabled]="buttonAcces.btnEliminar" pButton icon="{{globalConstants.icoEliminar}}" class="ui-button-danger" (click)="onToRowSelectDelete(modelo)"></button>
                                    <!-- <button pButton icon="{{globalConstants.icoEliminar}}" class="ui-button-danger" (click)="onToRowSelectDelete(modelo)"></button> -->
                                </td>
                            </tr>
                        </ng-template>

                    </p-table>
                    <p-footer>
                        <div class="ui-grid ui-fluid">
                            <div class="ui-g-12 ui-md-3">
                                <button [disabled]="buttonAcces.btnNuevo" pButton type="button" label="{{globalConstants.cNuevo}}" icon="{{globalConstants.icoNuevo}}" (click)="onToCreate()"></button>
                                <!-- <button pButton type="button" label="{{globalConstants.cNuevo}}" icon="{{globalConstants.icoNuevo}}" (click)="onToCreate()"></button> -->
                            </div>
                        </div>
                    </p-footer>
                </p-panel>
            </div>
        </div>
    </div>

</p-panel>

<!-- Para Eliminar -->
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"></p-confirmDialog>